// extracted by mini-css-extract-plugin
module.exports = {"notAccess":"_3CmJX","intro":"_1S9P0"};